// extracted by mini-css-extract-plugin
module.exports = {"main":"NotificationLayout-module__main--1cc_S","wrapper":"NotificationLayout-module__wrapper--3cet7"};